
<div class="row">
    <div class="col-md-12">

        <div class="card card-accent-success animated fadeIn container-filter">

            <a class="card-header-a" (click)="isCollapsedGrid = !isCollapsedGrid" [attr.aria-expanded]="!isCollapsedGrid" aria-controls="collapseExample">
                <div class="card-header-buscador">
                    <i class="fa fa-file-text-o"></i> Copias del Certificado Fitosanitario
                    <i *ngIf="isCollapsedGrid" class="fa fa-caret-down float-right"></i>
                    <i *ngIf="!isCollapsedGrid" class="fa fa-caret-up float-right"></i>
                </div>
            </a>

            <div class="card-body-detalle">

                <div class="collapse group-filtros-cf" id="collapseCopiasCf" [ngbCollapse]="isCollapsedGrid">

                    <label class="col-form-label">
                        <i class="fa fa-align-justify"></i> Listado de Copias de Certificado
                    </label>

                    <p-table #tableSearch autoLayout="true" [value]="copiasSolicitud"
                             [columns]="colsCopias" sortField="Codigo" sortOrder="-1"
                             styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                             [ngClass]="displayGridHidden(copiasSolicitud)">

                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                    {{col.header}}
                                    <p-sortIcon *ngIf="col.field!=='Link' && col.field!=='Image'" [field]="col.field"></p-sortIcon>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                            <tr>

                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                    <span *ngIf="(col.field!=='Link' && col.field!=='Image' && col.field!=='FechaPeticionCopia' && col.field!=='FechaInspeccionCopia' && col.field!=='FechaExpedicion' && col.field!=='FechaAnulacion')">
                                        {{rowData[col.field]}}
                                    </span>

                                    <span *ngIf="col.field==='Image'">
                                        <img class="estado-icono" src="{{rowData['IdEstadoCopiaCfEx'] | IconoCopiaCertificadoEx}}" container="body" ngbTooltip="{{rowData['IdEstadoCopiaCfExDescripcion']}}" />
                                    </span>

                                    <span *ngIf="col.field==='FechaPeticionCopia'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>
                                    <span *ngIf="col.field==='FechaInspeccionCopia'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>
                                    <span *ngIf="col.field==='FechaExpedicion'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>
                                    <span *ngIf="col.field==='FechaAnulacion'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>

                                    <div *ngIf="col.field==='Link'" class="btn-group">

                                        <div *ngIf="checkEdit(rowData)">
                                            <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                    class="btn btn-sm btn-warning">
                                                <span class="fa fa-edit"></span>

                                            </button>
                                        </div>
                                        <div *ngIf="!checkEdit(rowData)">
                                            <button (click)="onEdit(rowData)" type="button" title="Consultar"
                                                    class="btn btn-sm btn-info">
                                                <span class="fa fa-search"></span>

                                            </button>
                                        </div>

                                        <div *ngIf="checkDelete(rowData)">
                                            <button (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                    class="btn btn-sm btn-danger">
                                                <span class="fa fa-remove"></span>

                                            </button>
                                        </div>

                                    </div>
                                </td>
                            </tr>

                        </ng-template>
                    </p-table>
                </div>
                <div *ngIf="copiasSolicitud === null || copiasSolicitud?.length == 0" class="empty-grid">
                    No hay copias asociadas a la solicitud
                </div>
            </div>
        </div>
    </div>
</div>
